<template>
  <button
    type="button"
    class="icon-arrow-left-btn"
    :aria-label="ariaLabel || $t('message.accessibility.go_back')"
    @click="$emit('click', $event)"
    @keydown.enter="$emit('click', $event)"
    @keydown.space.prevent="$emit('click', $event)"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-8 w-8"
      :style="{ color: global.primaryColor }"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M10 19l-7-7m0 0l7-7m-7 7h18"
      />
    </svg>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'IconArrowLeft',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['click'],
  computed: {
    ...mapGetters(['global'])
  }
});
</script>

<style scoped>
.icon-arrow-left-btn {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-arrow-left-btn:focus {
  outline: 2px solid currentColor;
  outline-offset: 2px;
  border-radius: 4px;
}

.icon-arrow-left-btn:focus:not(:focus-visible) {
  outline: none;
}

.icon-arrow-left-btn:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 2px;
  border-radius: 4px;
}
</style>
